/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import UserStorage from "../storages/UserStorage";

const SiteHeader = () => {

    const [currentUser, setCurrentUser] = useState<string | undefined>(undefined);
    const [showMenu, setShowMenu] = useState<Boolean>(false);

    const navigate = useNavigate(); 

    /**
     * Method renders a login button depending on the current user status.
     * @returns JSX Element that represent an option to login to an existing guest account.
     */
    function renderLoginButton() {
        return (
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle text-white" href="#" style={{ fontSize: 20 }} onClick={e => setShowMenu(!showMenu)}>
                    <i className="bi bi-person-circle me-1" /> Profile
                </a>
                <ul className={showMenu ? "dropdown-menu show" : "dropdown-menu"}>
                    <li>
                        <a href="/login" className="dropdown-item">Login</a>
                    </li>
                </ul>
            </li>
        )
    }

    /**
     * Method renders a profile control button depending on the current user status.
     * @returns
     */
    function renderProfileButton() {
        return (
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle text-white" href="#" style={{ fontSize: 20 }} onClick={e => setShowMenu(!showMenu)}>
                    <i className="bi bi-person-circle me-1" />{UserStorage.getCurrentUser()?.username}
                </a>
                <ul className={showMenu ? "dropdown-menu show" : "dropdown-menu"}>
                    <li>
                        <a href="/me/claims" className="dropdown-item">Show my Claims</a>
                    </li>
                    <li>
                        <hr className="dropdown-divider"></hr>
                    </li>
                    <li>
                        <a className="dropdown-item" href="#" onClick={logoff}>Logoff</a>
                    </li>
                </ul>
            </li>
        )
    }

    /**
     * Destroys the current logged in user informations from the webstorage.
     */
    function logoff() {
        UserStorage.destroy();
        navigate("/login");
    }

    useEffect(() => {

        /* sets the current user if already authenticated */
        setCurrentUser(UserStorage.getCurrentUser()?.username)

    }, [])

    return (
        <nav className="navbar navbar-expand-md navbar-dark bg-primary px-4 mb-5">
            <div className="container">
                <NavLink to="/" className="navbar-brand">Academy of European Law</NavLink>
                <ul className="navbar-nav ml-auto">
                    {currentUser !== undefined ? renderProfileButton() : renderLoginButton()}
                </ul>
            </div>
        </nav>
    )

}
export default SiteHeader;